// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EpisodeDemographics_wrapper__2YuWI","container":"EpisodeDemographics_container__28KJC"};